export const bellyAndBrain = {
    name: 'Belly and Brain',
    logo: {
        path: 'partners/belly-and-brain-logo-white.svg',
        alt: 'Belly and Brain logo',
    },
};
